export default __webpack_public_path__ + "static/5-6d62c66d289e745bd024b1a894f6e1e1.jpeg";